if ( objects.is_front_page ) {

	const swiper_home = new Swiper('.swiper-home', {
		grabCursor: true,
		centeredSlides: true,
		loop: true,
		slidesPerView: 1,
		speed: 1000,
		// Navigation arrows
		navigation: {
			nextEl: '.swiper-home-button-next',
			prevEl: '.swiper-home-button-prev',
		},
		autoplay: {
			delay: 5000,
		}
	})

	const swiper_categories = new Swiper('.swiper-categories', {
		autoplay: {
			delay: 700,
		},
		speed: 1000,
		slidesPerView: 1.5,
		initialSlide: 0,
		grabCursor: true,
		centeredSlides: true,
		loop: true,
		spaceBetween: 20,
		watchOverflow: true,
		breakpoints: {
		472:{
			slidesPerView: 2,
		},
		768:{
			slidesPerView: 3,
		},
		992: {
			slidesPerView: 4,
		},
		1200: {
			slidesPerView: 5,
		},
		1600: {
			slidesPerView: 6,
		},
		1800: {
			slidesPerView: 7,
		}
		},
	
		// Navigation arrows
		navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
		},
	})

	//register the plugin (just once)
	// gsap.registerPlugin(MotionPathPlugin);
}

jQuery( document ).ready(function() {
	const popDown = document.querySelector(".pop-down")
	
	popDown.querySelector(".handle").addEventListener("click", () => {
		if(popDown.classList.contains("open")){
			if(window.innerWidth >= 768){
				popDown.style.right = "-247px"
			} else {
				popDown.style.right = "-308px"
			}
			popDown.classList.remove("open")
		} else {
			popDown.style.right = "-50px"
			popDown.classList.add("open")
		}
	})

	window.addEventListener("resize", () => {
		if(popDown.classList.contains("open")){
			return
		} else {
			if(window.innerWidth >= 768){
				popDown.style.right = "-247px"
			} else {
				popDown.style.right = "-308px"
			}
		}
	})

	setTimeout(() => {
		if(popDown.classList.contains("open")){
			if(window.innerWidth >= 768){
				popDown.style.right = "-247px"
			} else {
				popDown.style.right = "-308px"
			}
			popDown.classList.remove("open")
		}
	}, 3000)

	Array.from(document.querySelectorAll('#gform_submit_button_5')).forEach(element => {
		element.innerHTML = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.87451 5.69818L1.7315 0.618815C1.56124 0.456414 1.28993 0.461076 1.12549 0.629231C0.965075 0.793269 0.965075 1.05331 1.12549 1.21733L5.96549 5.99744L1.12549 10.7775C0.958169 10.9428 0.958169 11.2108 1.12549 11.3761C1.29287 11.5413 1.56415 11.5413 1.7315 11.3761L6.87451 6.29669C7.04183 6.13139 7.04183 5.86346 6.87451 5.69818Z" fill="white" stroke="white"/></svg>'
	})
	
	Array.from(document.querySelectorAll('button')).forEach(element => {
		if(element.innerHTML === '&gt;'){
			element.innerHTML = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.87451 5.69818L1.7315 0.618815C1.56124 0.456414 1.28993 0.461076 1.12549 0.629231C0.965075 0.793269 0.965075 1.05331 1.12549 1.21733L5.96549 5.99744L1.12549 10.7775C0.958169 10.9428 0.958169 11.2108 1.12549 11.3761C1.29287 11.5413 1.56415 11.5413 1.7315 11.3761L6.87451 6.29669C7.04183 6.13139 7.04183 5.86346 6.87451 5.69818Z" fill="white" stroke="white"/></svg>'
		}
	})

	if(document.querySelector('.post-type-archive-formations') || document.querySelector('.tax-category-formation')){
		const notch = document.querySelector('.notch')
		notch.addEventListener("click", () => {
			if(notch.parentNode.classList.contains('open')){
				notch.parentNode.classList.remove('open')
				notch.parentNode.style.height = "50px"
			} else {
				notch.parentNode.classList.add('open')
				notch.parentNode.style.height = notch.parentNode.querySelector('.sidebar-wrap').getBoundingClientRect().height + notch.getBoundingClientRect().height + "px"
			}
		})
	}

	document.addEventListener("resize", () => {
		if(notch.parentNode.classList.contains('open')){
			notch.parentNode.style.height = notch.parentNode.querySelector('.sidebar-wrap').getBoundingClientRect().height + notch.getBoundingClientRect().height + "px"
		} else {
			notch.parentNode.style.height = "50px"
		}
	})

	jQuery('#navbar-toggle').on('input', function() {
		jQuery('#menu-item-754 .dropdown-toggle, #menu-item-754 .dropdown-menu').addClass('show');
	});

	// if(document.querySelector('.wrap-tags')){
	// 	document.querySelector('.wrap-tags').querySelectorAll('.tag').forEach(element => {
	// 		console.log(element)
	// 		element.style.width = element.querySelector('span').clientWidth + 10 + "px"
	// 		console.log(element.querySelector('span').clientWidth)
	// 	})
	// }

	jQuery('body').on('click', '.nav-link, #breadcrumbs a', function(e) {
		sessionStorage.removeItem("nbformations");
		sessionStorage.removeItem("indexformation");
	});
})

AOS.init()